module.exports = __webpack_public_path__ + "static/media/synced.f41767bc.svg";